module.exports = __webpack_public_path__ + "static/media/sepafinIcon.1c7bde63.svg";